import { useCurrentUser } from '@bonusly/who-am-i';

export type Role =
	| 'announcements_admin'
	| 'awards_admin'
	| 'award_approver'
	| 'finance_admin'
	| 'global_admin'
	| 'rewards_admin'
	| 'show_superadmin_feature'
	| 'tech_ops_admin'
	| 'tech_admin';

export class User {
	constructor(private data: ReturnType<typeof useCurrentUser>) {}

	public hasAnyRole(...roles: Role[]) {
		if (!roles.length) return true;
		return roles.some((role) => this.data[role]);
	}
}
